module.exports = __webpack_public_path__ + "images/emoji/hourglass_flowing_sand.bb173c1cd15a8a9bd3ac.png";